export default __webpack_public_path__ + "static/media/Screenshot_16.a02763ba.png";